import {CenterHero, TicketHero} from "../../blocks/hero/Hero";
import {PrimaryButton} from "../../components/button/Button";
import {Footer} from "../../blocks/footer/Footer";
import {Presenter} from "../../blocks/presenter/Presenter";
import {useLoaderData, useParams, useRouteLoaderData} from "react-router-dom";
import {API, Entities} from "../../utils/Api";

export default function PresenterPage(){
    const {id} = useParams();
    const data = useLoaderData();
    var presenter = data.presenter;

    /*
    const presenter={
        imgUrl:"https://dev-admin.benefitprize.hu/mediatar/file/original/9BB83ECE-6001-4B2A-B2BA.jpg",
        companyUrl:'',
        companyName:'',
        position:'',
        facebookUrl:'',
        linkedInUrl:'',
        category:'design',
        filters:['web','selected'],
        name:'Előadó 1',
        bio:'Bemutatkozás',
        presentations:[
            {
                title: 'Előadás az első blokkban elsőként',
                presenters: ['Elsős Ruheen'],
                from: '10:00 AM',
                to: '12:30 PM',
                description: 'Leírás'
            }
        ],
        badge:{
            title:'',
            icon:''
        },
        awards:[
            {
                title: '',
                icon:''
            }
        ]

    };
     */

    return(
        <>
        <CenterHero
            url={'/benefitshare/img/headerbg3.jpg'}
            megaphone={'Shaping success, sharing great ideas'}
            titles={['Előadó']}
            fill={'#ffffff'}
        ></CenterHero>
            <Presenter presenter={presenter}></Presenter>
            <TicketHero titles={["Sharing ideas, shaping success.Big ideas for happy employees."]} megaphone={"Let's make something great work together."}>
                <PrimaryButton href={'/jegyek'} primaryText={'Jegy vásárlása'} secondaryText={"Biztosítsd a helyedet"}></PrimaryButton>
            </TicketHero>
            <Footer></Footer>

        </>
    )
}


export async function PresenterLoader({params}){  // Az async kulcsszó kell a Promise kezeléséhez
    const { id } = params;  // Kivesszük az id-t a params-ból
    try {
        const response = await API.rest(Entities.presenter, "GET",null, id); // Várjuk meg az API választ
        return {
            presenter: response,
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { presenter: []}; // Hiba esetén üres tömböt adunk vissza
    }
}